"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _webexCore = require("@webex/webex-core");
var _uuid = _interopRequireDefault(require("uuid"));
var _lodash = require("lodash");
var _constants = require("../constants");
var _collection = _interopRequireDefault(require("./collection"));
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
/*!
 * Copyright (c) 2015-2023 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * @class Webinar
 */
var Webinar = _webexCore.WebexPlugin.extend({
  namespace: _constants.MEETINGS,
  collections: {
    webinar: _collection.default
  },
  props: {
    locusUrl: 'string',
    // appears current webinar's locus url
    webcastInstanceUrl: 'string',
    // current webinar's webcast instance url
    canManageWebcast: 'boolean',
    // appears the ability to manage webcast
    selfIsPanelist: 'boolean',
    // self is panelist
    selfIsAttendee: 'boolean',
    // self is attendee
    practiceSessionEnabled: 'boolean',
    // practice session enabled
    meetingId: 'string'
  },
  /**
   * Update the current locus url of the webinar
   * @param {string} locusUrl
   * @returns {void}
   */
  locusUrlUpdate: function locusUrlUpdate(locusUrl) {
    this.set('locusUrl', locusUrl);
  },
  /**
   * Update the current webcast instance url of the meeting
   * @param {object} payload
   * @returns {void}
   */
  updateWebcastUrl: function updateWebcastUrl(payload) {
    this.set('webcastInstanceUrl', (0, _lodash.get)(payload, 'resources.webcastInstance.url'));
  },
  /**
   * Update whether self has capability to manage start/stop webcast (only host can manage it)
   * @param {boolean} canManageWebcast
   * @returns {void}
   */
  updateCanManageWebcast: function updateCanManageWebcast(canManageWebcast) {
    this.set('canManageWebcast', canManageWebcast);
  },
  /**
   * Updates user roles and manages associated state transitions
   * @param {object} payload
   * @param {string[]} payload.oldRoles - Previous roles of the user
   * @param {string[]} payload.newRoles - New roles of the user
   * @returns {{isPromoted: boolean, isDemoted: boolean}} Role transition states
   */
  updateRoleChanged: function updateRoleChanged(payload) {
    var oldRoles = (0, _lodash.get)(payload, 'oldRoles', []);
    var newRoles = (0, _lodash.get)(payload, 'newRoles', []);
    var isPromoted = oldRoles.includes(_constants.SELF_ROLES.ATTENDEE) && newRoles.includes(_constants.SELF_ROLES.PANELIST);
    var isDemoted = oldRoles.includes(_constants.SELF_ROLES.PANELIST) && newRoles.includes(_constants.SELF_ROLES.ATTENDEE) || !oldRoles.includes(_constants.SELF_ROLES.ATTENDEE) && newRoles.includes(_constants.SELF_ROLES.ATTENDEE); // for attendee just join meeting case
    this.set('selfIsPanelist', newRoles.includes(_constants.SELF_ROLES.PANELIST));
    this.set('selfIsAttendee', newRoles.includes(_constants.SELF_ROLES.ATTENDEE));
    this.updateCanManageWebcast(newRoles.includes(_constants.SELF_ROLES.MODERATOR));
    this.updateStatusByRole({
      isPromoted: isPromoted,
      isDemoted: isDemoted
    });
    return {
      isPromoted: isPromoted,
      isDemoted: isDemoted
    };
  },
  /**
   * should join practice session data channel or not
   * @param {Object} {isPromoted: boolean, isDemoted: boolean}} Role transition states
   * @returns {void}
   */
  updateStatusByRole: function updateStatusByRole(_ref) {
    var isPromoted = _ref.isPromoted,
      isDemoted = _ref.isDemoted;
    var meeting = this.webex.meetings.getMeetingByType(_constants._ID_, this.meetingId);
    if (isDemoted && (meeting === null || meeting === void 0 ? void 0 : meeting.shareStatus) === _constants.SHARE_STATUS.WHITEBOARD_SHARE_ACTIVE || isPromoted) {
      var _meeting$locusInfo, _meeting$locusInfo2;
      // attendees in webinar should subscribe streaming for whiteboard sharing
      // while panelist still need subscribe native mode so trigger force update here
      meeting === null || meeting === void 0 ? void 0 : (_meeting$locusInfo = meeting.locusInfo) === null || _meeting$locusInfo === void 0 ? void 0 : _meeting$locusInfo.updateMediaShares(meeting === null || meeting === void 0 ? void 0 : (_meeting$locusInfo2 = meeting.locusInfo) === null || _meeting$locusInfo2 === void 0 ? void 0 : _meeting$locusInfo2.mediaShares, true);
    }
    if (this.practiceSessionEnabled) {
      // may need change data channel in practice session
      meeting === null || meeting === void 0 ? void 0 : meeting.updateLLMConnection();
    }
  },
  /**
   * should join practice session data channel or not
   * @returns {boolean}
   */
  isJoinPracticeSessionDataChannel: function isJoinPracticeSessionDataChannel() {
    return this.selfIsPanelist && this.practiceSessionEnabled;
  },
  /**
   * start or stop practice session for webinar
   * @param {boolean} enabled
   * @returns {Promise}
   */
  setPracticeSessionState: function setPracticeSessionState(enabled) {
    return this.request({
      method: _constants.HTTP_VERBS.PATCH,
      uri: "".concat(this.locusUrl, "/controls"),
      body: {
        practiceSession: {
          enabled: enabled
        }
      }
    }).catch(function (error) {
      _loggerProxy.default.logger.error('Meeting:webinar#setPracticeSessionState failed', error);
      throw error;
    });
  },
  /**
   * update practice session status
   * @param {object} payload
   * @returns {void}
   */
  updatePracticeSessionStatus: function updatePracticeSessionStatus(payload) {
    this.set('practiceSessionEnabled', payload.enabled);
  },
  /**
   * start webcast mode for webinar
   * @param {object} meeting
   * @param {object} layout
   * @returns {Promise}
   */
  startWebcast: function startWebcast(meeting, layout) {
    var _this = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (meeting) {
              _context.next = 3;
              break;
            }
            _loggerProxy.default.logger.error("Meeting:webinar#startWebcast failed --> meeting parameter : ".concat(meeting));
            throw new Error('Meeting parameter does not meet expectations');
          case 3:
            _context.t0 = _this;
            _context.t1 = _constants.HTTP_VERBS.PUT;
            _context.t2 = "".concat(_this.webcastInstanceUrl, "/streaming");
            _context.t3 = _defineProperty2.default;
            _context.next = 9;
            return _this.webex.credentials.getUserToken();
          case 9:
            _context.t4 = _context.sent;
            _context.t5 = "".concat(_webexCore.config.trackingIdPrefix, "_").concat(_uuid.default.v4().toString());
            _context.t6 = {
              authorization: _context.t4,
              trackingId: _context.t5
            };
            _context.t7 = _constants.HEADERS.CONTENT_TYPE;
            _context.t8 = _constants.HEADERS.CONTENT_TYPE_VALUE.APPLICATION_JSON;
            _context.t9 = (0, _context.t3)(_context.t6, _context.t7, _context.t8);
            _context.t10 = {
              action: 'start',
              meetingInfo: {
                locusId: meeting.locusId,
                correlationId: meeting.correlationId
              },
              layout: layout
            };
            _context.t11 = {
              method: _context.t1,
              uri: _context.t2,
              headers: _context.t9,
              body: _context.t10
            };
            return _context.abrupt("return", _context.t0.request.call(_context.t0, _context.t11).catch(function (error) {
              _loggerProxy.default.logger.error('Meeting:webinar#startWebcast failed', error);
              throw error;
            }));
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  /**
   * stop webcast mode for webinar
   * @returns {Promise}
   */
  stopWebcast: function stopWebcast() {
    var _this2 = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = _this2;
            _context2.t1 = _constants.HTTP_VERBS.PUT;
            _context2.t2 = "".concat(_this2.webcastInstanceUrl, "/streaming");
            _context2.t3 = _defineProperty2.default;
            _context2.next = 6;
            return _this2.webex.credentials.getUserToken();
          case 6:
            _context2.t4 = _context2.sent;
            _context2.t5 = "".concat(_webexCore.config.trackingIdPrefix, "_").concat(_uuid.default.v4().toString());
            _context2.t6 = {
              authorization: _context2.t4,
              trackingId: _context2.t5
            };
            _context2.t7 = _constants.HEADERS.CONTENT_TYPE;
            _context2.t8 = _constants.HEADERS.CONTENT_TYPE_VALUE.APPLICATION_JSON;
            _context2.t9 = (0, _context2.t3)(_context2.t6, _context2.t7, _context2.t8);
            _context2.t10 = {
              action: 'stop'
            };
            _context2.t11 = {
              method: _context2.t1,
              uri: _context2.t2,
              headers: _context2.t9,
              body: _context2.t10
            };
            return _context2.abrupt("return", _context2.t0.request.call(_context2.t0, _context2.t11).catch(function (error) {
              _loggerProxy.default.logger.error('Meeting:webinar#stopWebcast failed', error);
              throw error;
            }));
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  /**
   * query webcast layout for webinar
   * @returns {Promise}
   */
  queryWebcastLayout: function queryWebcastLayout() {
    var _this3 = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = _this3;
            _context3.t1 = _constants.HTTP_VERBS.GET;
            _context3.t2 = "".concat(_this3.webcastInstanceUrl, "/layout");
            _context3.next = 5;
            return _this3.webex.credentials.getUserToken();
          case 5:
            _context3.t3 = _context3.sent;
            _context3.t4 = "".concat(_webexCore.config.trackingIdPrefix, "_").concat(_uuid.default.v4().toString());
            _context3.t5 = {
              authorization: _context3.t3,
              trackingId: _context3.t4
            };
            _context3.t6 = {
              method: _context3.t1,
              uri: _context3.t2,
              headers: _context3.t5
            };
            return _context3.abrupt("return", _context3.t0.request.call(_context3.t0, _context3.t6).catch(function (error) {
              _loggerProxy.default.logger.error('Meeting:webinar#queryWebcastLayout failed', error);
              throw error;
            }));
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  /**
   * update webcast layout for webinar
   * @param {object} layout
   * @returns {Promise}
   */
  updateWebcastLayout: function updateWebcastLayout(layout) {
    var _this4 = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.t0 = _this4;
            _context4.t1 = _constants.HTTP_VERBS.PUT;
            _context4.t2 = "".concat(_this4.webcastInstanceUrl, "/layout");
            _context4.t3 = _defineProperty2.default;
            _context4.next = 6;
            return _this4.webex.credentials.getUserToken();
          case 6:
            _context4.t4 = _context4.sent;
            _context4.t5 = "".concat(_webexCore.config.trackingIdPrefix, "_").concat(_uuid.default.v4().toString());
            _context4.t6 = {
              authorization: _context4.t4,
              trackingId: _context4.t5
            };
            _context4.t7 = _constants.HEADERS.CONTENT_TYPE;
            _context4.t8 = _constants.HEADERS.CONTENT_TYPE_VALUE.APPLICATION_JSON;
            _context4.t9 = (0, _context4.t3)(_context4.t6, _context4.t7, _context4.t8);
            _context4.t10 = {
              videoLayout: layout.videoLayout,
              contentLayout: layout.contentLayout,
              syncStageLayout: layout.syncStageLayout,
              syncStageInMeeting: layout.syncStageInMeeting
            };
            _context4.t11 = {
              method: _context4.t1,
              uri: _context4.t2,
              headers: _context4.t9,
              body: _context4.t10
            };
            return _context4.abrupt("return", _context4.t0.request.call(_context4.t0, _context4.t11).catch(function (error) {
              _loggerProxy.default.logger.error('Meeting:webinar#updateWebcastLayout failed', error);
              throw error;
            }));
          case 15:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  /**
   * view all webcast attendees
   * @param {string} queryString
   * @returns {Promise}
   */
  viewAllWebcastAttendees: function viewAllWebcastAttendees() {
    var _this5 = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.t0 = _this5;
            _context5.t1 = _constants.HTTP_VERBS.GET;
            _context5.t2 = "".concat(_this5.webcastInstanceUrl, "/attendees");
            _context5.next = 5;
            return _this5.webex.credentials.getUserToken();
          case 5:
            _context5.t3 = _context5.sent;
            _context5.t4 = "".concat(_webexCore.config.trackingIdPrefix, "_").concat(_uuid.default.v4().toString());
            _context5.t5 = {
              authorization: _context5.t3,
              trackingId: _context5.t4
            };
            _context5.t6 = {
              method: _context5.t1,
              uri: _context5.t2,
              headers: _context5.t5
            };
            return _context5.abrupt("return", _context5.t0.request.call(_context5.t0, _context5.t6).catch(function (error) {
              _loggerProxy.default.logger.error('Meeting:webinar#viewAllWebcastAttendees failed', error);
              throw error;
            }));
          case 10:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  /**
   * search webcast attendees by query string
   * @param {string} queryString
   * @returns {Promise}
   */
  searchWebcastAttendees: function searchWebcastAttendees() {
    var _arguments = arguments,
      _this6 = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
      var queryString;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            queryString = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : '';
            _context6.t0 = _this6;
            _context6.t1 = _constants.HTTP_VERBS.GET;
            _context6.t2 = "".concat(_this6.webcastInstanceUrl, "/attendees?keyword=").concat(encodeURIComponent(queryString));
            _context6.next = 6;
            return _this6.webex.credentials.getUserToken();
          case 6:
            _context6.t3 = _context6.sent;
            _context6.t4 = "".concat(_webexCore.config.trackingIdPrefix, "_").concat(_uuid.default.v4().toString());
            _context6.t5 = {
              authorization: _context6.t3,
              trackingId: _context6.t4
            };
            _context6.t6 = {
              method: _context6.t1,
              uri: _context6.t2,
              headers: _context6.t5
            };
            return _context6.abrupt("return", _context6.t0.request.call(_context6.t0, _context6.t6).catch(function (error) {
              _loggerProxy.default.logger.error('Meeting:webinar#searchWebcastAttendees failed', error);
              throw error;
            }));
          case 11:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  /**
   * expel webcast attendee by participantId
   * @param {string} participantId
   * @returns {Promise}
   */
  expelWebcastAttendee: function expelWebcastAttendee(participantId) {
    var _this7 = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.t0 = _this7;
            _context7.t1 = _constants.HTTP_VERBS.DELETE;
            _context7.t2 = "".concat(_this7.webcastInstanceUrl, "/attendees/").concat(participantId);
            _context7.next = 5;
            return _this7.webex.credentials.getUserToken();
          case 5:
            _context7.t3 = _context7.sent;
            _context7.t4 = "".concat(_webexCore.config.trackingIdPrefix, "_").concat(_uuid.default.v4().toString());
            _context7.t5 = {
              authorization: _context7.t3,
              trackingId: _context7.t4
            };
            _context7.t6 = {
              method: _context7.t1,
              uri: _context7.t2,
              headers: _context7.t5
            };
            return _context7.abrupt("return", _context7.t0.request.call(_context7.t0, _context7.t6).catch(function (error) {
              _loggerProxy.default.logger.error('Meeting:webinar#expelWebcastAttendee failed', error);
              throw error;
            }));
          case 10:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  version: "3.7.0-web-workers-keepalive.1"
});
var _default = exports.default = Webinar;
//# sourceMappingURL=index.js.map
